export const SITE_NAME = "Coval Flow";
export const SITE_URL = "https://clovalflow.com";

/**
 * Set to true to enable /:lang/* routing (e.g. /en/, /fr/).
 * Set to false for a single-language app — standard routing is used instead.
 */
export const I18N_ROUTING = true;
